import classes from './about.module.scss'

import { Link } from 'react-scroll'
import { motion } from 'framer-motion'

import TechStack from '../../components/tech/TechStack'

const About = () => {
  const email = 'stina.nerin@gmail.com'
  const ariaLabel = 'Contact Stina via email.'

  return (
    <motion.div
      className="page-section "
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.75, ease: 'easeOut' }}
    >
      <div className={classes.about__section}>
        <h2 className={classes.about__section__title}>So, who am I?</h2>
        <p>
          Frontend Developer with a fondness for putting pen to paper. Coding
          for me is like getting to solve puzzles full-time. There is no better
          feeling than when you solve a tricky problem or when all the pieces
          fall into place. I approach issues methodically, breaking them down
          into solvable parts. Please explore my technical arsenal below but
          don't be fooled. My weapon of choice for picking a problem apart will
          always be a post-it and glitter gel pen.
        </p>
        <p>And yes, I am social, but when I work, I work 😊</p>
        {
          //
        }
        <p>
          Check out my projects{' '}
          <Link
            smooth={true}
            duration={500}
            to="/work"
            offset={32}
            className="link"
          >
            here
          </Link>
          .
        </p>
        <p>
          Reach me at{' '}
          <a className="link" href={`mailto:${email}`} aria-label={ariaLabel}>
            {email}
          </a>{' '}
          to say hi!
        </p>
      </div>
      <div className="center">
        <TechStack />
      </div>
    </motion.div>
  )
}

export default About
